import { render } from "./_session-tag.vue?vue&type=template&id=3fc18820&lang=pug"
import script from "./_session-tag.vue?vue&type=script&lang=js"
export * from "./_session-tag.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__